import { render, staticRenderFns } from "./main-panel.vue?vue&type=template&id=3205ccee&scoped=true"
import script from "./main-panel.vue?vue&type=script&lang=js"
export * from "./main-panel.vue?vue&type=script&lang=js"
import style0 from "./main-panel.vue?vue&type=style&index=0&id=3205ccee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3205ccee",
  null
  
)

export default component.exports